import * as Popover from '@radix-ui/react-popover'
import { type NodeViewProps } from '@tiptap/core'
import { NodeViewWrapper } from '@tiptap/react'
import React, { useRef } from 'react'
import { Input } from '#app/components/ui/input.js'
import { CUSTOMIZER_MAX_WIDTH } from '#app/utils/constants.js'

export const Component = (props: NodeViewProps) => {
	const { editor } = props
	const spacing = props.node.attrs.spacing || 10
	const editable = editor.isEditable
	const startY = useRef(0)
	const startSpacing = useRef(spacing)

	const nodeViewRef = useRef<HTMLDivElement>(null)

	const onMouseDown = (e: React.MouseEvent, p0: string) => {
		e.preventDefault()
		startY.current = e.clientY
		startSpacing.current = spacing
		document.addEventListener('mousemove', onMouseMove)
		document.addEventListener('mouseup', onMouseUp)
	}

	const onMouseMove = (e: MouseEvent) => {
		const deltaY = e.clientY - startY.current
		const deltaSteps = Math.round(deltaY / 4)
		const newSpacing = Math.max(0, startSpacing.current + deltaSteps * 4)

		props.updateAttributes({ spacing: newSpacing })
	}

	const onMouseUp = () => {
		document.removeEventListener('mousemove', onMouseMove)
		document.removeEventListener('mouseup', onMouseUp)
	}

	if (editable) {
		return (
			<NodeViewWrapper ref={nodeViewRef}>
				<Popover.Root>
					<Popover.Trigger asChild>
						<div
							className="wtls-block-divider group flex cursor-ns-resize flex-col"
							onMouseDown={e => onMouseDown(e, 'top')}
						>
							<div
								className="!transition-none"
								style={{
									paddingTop: `${spacing}px`,
									paddingBottom: `${spacing}px`,
								}}
							>
								<hr
									className="hr-tt w-full max-w-full"
									style={{ width: CUSTOMIZER_MAX_WIDTH + 'px' }}
								/>
							</div>
						</div>
					</Popover.Trigger>
					<Popover.Portal>
						<Popover.Content
							onOpenAutoFocus={e => e.preventDefault()}
							className="custom-popover z-50 flex w-24 items-center gap-2 rounded-xl border border-border bg-white p-2 shadow-sm"
							sideOffset={8}
						>
							<label
								className="relative flex flex-col items-center gap-2"
								data-tooltip="Spacing"
								data-tooltip-direction="up"
							>
								<Input
									defaultValue={props.node.attrs.spacing}
									value={props.node.attrs.spacing}
									type="number"
									step={4}
									min={4}
									onChange={e =>
										props.updateAttributes({ spacing: e.currentTarget.value })
									}
									variant="s"
									iconText="PX"
								/>
							</label>
						</Popover.Content>
					</Popover.Portal>
				</Popover.Root>
			</NodeViewWrapper>
		)
	} else {
		return (
			<NodeViewWrapper
				as="hr"
				className="hr-tt w-[420px] max-w-full"
				style={{
					marginTop: `${spacing}px`,
					marginBottom: `${spacing}px`,
				}}
			/>
		)
	}
}

export default Component
